import { useAuth } from "@/hooks/useAuth";

export function StartingUpPage() {
  const { apiRetryCount, retryApiConnection } = useAuth();

  return (
    <div className="login-page">
      <div className="login-card startup-card">
        <div className="login-brand">
          <span className="login-brand-mark-frame" aria-hidden="true">
            <img className="login-brand-mark" src="/knotfin-logo-v3.png" alt="" />
          </span>
          <h1 className="login-brand-title">KnotFin</h1>
        </div>
        <div className="startup-copy">
          <h2>Starting up</h2>
          <p>The API is not responding yet. Retrying automatically.</p>
          <div className="startup-status" role="status" aria-live="polite">
            <span className="startup-spinner" aria-hidden="true" />
            <span>Connection check {apiRetryCount}</span>
          </div>
          <button className="startup-retry-button" type="button" onClick={retryApiConnection}>
            Retry now
          </button>
        </div>
      </div>
    </div>
  );
}
